import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogComponentBase } from '@wephone-core-ui';
import { EnterpriseRepository } from '@wephone-core/model/repository/enterprise';
import { _ti } from '@wephone-translation';

@Component({
  selector: 'live-tracking-modal',
  templateUrl: './live-tracking-modal.html',
  styleUrls: ['./live-tracking-modal.scss']
})
export class LiveTrackingModalComponent extends DialogComponentBase implements OnInit {
  dialogTitle = `${_ti('user.content.live_tracking')} ${EnterpriseRepository.getInstance<EnterpriseRepository>().getMyEnterprise().name}`;

  displayGroup: false;
  filterValue = '';

  constructor(
    dialogRef: MatDialogRef<LiveTrackingModalComponent>,
    cdr: ChangeDetectorRef
  ) {
    super(dialogRef, cdr);
  }
}
